module.exports = __webpack_public_path__ + "static/image8-d56b61f66155e6edc122366cc2ecac09.jpg";